<template>
    <v-container fluid fill-height>
        <v-row>
            <v-spacer></v-spacer>
            <v-col cols="4" class="text-center">
                <h1 class="not_found_header">404</h1>
                <p class="not_found_text">Page not found</p>
                <router-link tag="a" to="/" class="not_found_text_href">Back to main page</router-link>
            </v-col>
            <v-spacer></v-spacer>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: "NotFound",
    created() {
        this.$vuetify.theme.dark = true;
    }
};
</script>
